import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DeleteUserModal from './DeleteUserModal';
import T from '../../../app/Locale';
const DeleteUserButton = ({ firstName }) => {
    const [showModal, toggleModal] = useState(false);
    return (_jsxs("div", { children: [showModal && (_jsx(DeleteUserModal, { firstName: firstName, closeModal: () => toggleModal(false) })), _jsxs("button", Object.assign({ type: 'button', className: 'button transparent', onClick: () => toggleModal(true), "data-behat-action": 'delete' }, { children: [_jsx("i", { className: 'fa fa-trash-alt button-left-icon' }), T.translate('user.delete')] }))] }));
};
DeleteUserButton.propTypes = { firstName: PropTypes.string };
export default DeleteUserButton;
